let prefix = '/api/sap/deliveries';
function getDeliveries(date1, date2) {
    return window.axios.get(prefix+'/index?date1='+date1+'&date2='+date2)
}
export default {
    getDeliveries,
}